import React from 'react'

import { Virtuoso, VirtuosoProps } from 'react-virtuoso'

export type VirtualizedListProps<T> = Pick<
  VirtuosoProps<T, unknown>,
  | 'components'
  | 'computeItemKey'
  | 'data'
  | 'increaseViewportBy'
  | 'initialTopMostItemIndex'
  | 'itemContent'
  | 'overscan'
> & {
  style?: React.CSSProperties
}

const DEFAULT_INCREASE_VIEWPORT_BY = 400

const VirtualizedList = <T,>(props: VirtualizedListProps<T>) => {
  const {
    increaseViewportBy = DEFAULT_INCREASE_VIEWPORT_BY,
    style,
    ...rest
  } = props

  return (
    <Virtuoso
      increaseViewportBy={increaseViewportBy}
      style={{ flex: 1, minHeight: 0, ...style }}
      {...rest}
    />
  )
}

export default VirtualizedList
